export default function (app) {
  app.controller('klCustomerCenterCancelEnterpriseCtrl', [
    '$state',
    '$window',
    'klSubscriptionService',
    function ($state, $window, SubscriptionService) {
      this.isLoading = false;
      this.abort = function () {
        $state.go('subscription');
      };
      this.confirm = function () {
        this.isLoading = true;
        SubscriptionService.cancelEnterprise(
          $state.params.enterpriseData.email,
          $state.params.enterpriseData.companyName,
          $state.params.enterpriseData.fullName,
          $state.params.enterpriseData.subscriptionId,
        ).then(() => {
          this.isLoading = false;
          $state.go('subscription.enterprise-cancelled');
        });
      };
    },
  ]);
}
